import React from 'react'

export default function CheckboxCircle(props) {
  return (
    <svg
      width={props.width ? props.width : '13'}
      height={props.height ? props.height : '13'}
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.4987 11.9173C3.50707 11.9173 1.08203 9.49228 1.08203 6.50065C1.08203 3.50903 3.50707 1.08398 6.4987 1.08398C9.49032 1.08398 11.9154 3.50903 11.9154 6.50065C11.9154 9.49228 9.49032 11.9173 6.4987 11.9173ZM5.95866 8.66732L9.78824 4.83719L9.02232 4.07128L5.95866 7.13548L4.42628 5.60311L3.66037 6.36903L5.95866 8.66732Z'
        fill={props.color ? props.color : '#0A8DE1'}
      />
    </svg>
  )
}
